// copied from https://codesandbox.io/s/81zkxw8qnl?file=/src/useRecorder.js

import { useEffect, useState } from "react";

const useRecorder = () => {
  const [audioURL, setAudioURL] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState(null);
  const [recordingStarted, setRecordingStarted] = useState(false);

  useEffect(() => {
    // Lazily obtain recorder first time we're recording.
    if (recorder === null) {
      if (isRecording) {
        requestRecorder().then(setRecorder, console.error);
      }
      return;
    }

    // Manage recorder state.
    if (isRecording) {
      recorder.start();
      setTimeout(() => setRecordingStarted(true), 100);

    } else {
      recorder.stop();
      setRecordingStarted(false);
    }

    // Obtain the audio when ready.
    const handleData = e => {
      const url = URL.createObjectURL(e.data);
      setAudioURL(url);
      console.log("audiourl is ready");
      console.log(audioURL);
      console.log(url);
    };

    recorder.addEventListener("dataavailable", handleData);
    return () => recorder.removeEventListener("dataavailable", handleData);
  }, [recorder, isRecording]);

  const startRecording = () => {
    setIsRecording(true);
  };

  const stopRecording = () => {
    setIsRecording(false);
  };

  const resetAudio = () => {
      URL.revokeObjectURL(audioURL);
      setAudioURL('');
  }

  const setAudioUrl = (url) => {
    setAudioURL(url);
  }

  return [audioURL, resetAudio, isRecording, startRecording, stopRecording, setAudioUrl, recordingStarted];
};

async function requestRecorder() {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  return new MediaRecorder(stream);
}
export default useRecorder;
